<template>
  <div class="shared-hotel-app-restore-store">
    <nav-bar class="nav-bar" titleText="适用门店" fontColor="#333333" @goBack="goBack">
      <template v-slot:default>
        <div class="nav-bar-right" @click="breakEvent('1')">
          <img src="../../assets/shared-hotel/break.png" :class="{'turn': turn}">
          <p>刷新定位</p>
        </div>
      </template>
    </nav-bar>
    <div class="topcontent" :style="issearch?'box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);':'box-shadow: 0px 0px 0px 0px ;'">
        <div class="top-search-div">
            <input v-model="searchvalue" placeholder="请输入店铺名称" @focus="goDeatilSearch"/>
            <div class="search-icon"><img src="../../assets/shared-hotel/search.png" /></div>
        </div>
        <!-- padding:0px 10px 12px;padding:10px 12px; -->
        <div class="condition" :style="issearch?'background:#fff;':'background:#f5f5f5;'">
        <div
            v-for="(item, i) in selectedList"
            :key="i"
            class="tag" 
            :class="{'tag-active': item.selected}"
            @click="clickCondition(item)"
        >{{ item.text }}</div>
        </div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="padding-top:44px;">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="50">
        <div class="empty-placehoder"></div>
        <div class="list-box" v-for="(item, i) in list" :key="i">
          <div class="list-box-warpper">
          <div class="list-box-left">
            <img :src="item.logo" alt="">
          </div>
          <div class="list-box-right">
            <div class="content">
              <div class="left" @click="toStoreInfo(item)">
                <div class="title">
                  <span class="t-left">{{item.shop_name}}</span>
                  <span class="t-right" v-if="item.distance">{{`${((item.distance)/1000).toFixed(2)}km`}}</span>
                </div>
                <div class="addres">{{item.address}}{{item.house_number}}</div>
              </div>
              <div class="right" @click="getMap(item)">
                <img src="../../assets/shared-hotel/position1.png" alt="">
              </div>
            </div>
            <span class="left-amount">剩余可充值额度：{{item.quota_data && parseFloat(item.quota_data.actual_rechargeable_amount).toFixed(2)}}</span>
            <p><span class="right-amount">未核销额度：{{item.quota_data &&parseFloat(item.quota_data.recharged_amount-item.quota_data.consumed_amount) > 0 ? item.quota_data && parseFloat(item.quota_data.recharged_amount-item.quota_data.consumed_amount).toFixed(2):0.00}}</span></p>
            <div class="discounts" :style="item.isfold?'':'height:20px;overflow: hidden;'"  v-if="item.recharge_promotion.length>0">
              <div class="discount" v-for="(item1, i) in item.recharge_promotion" :key="i">充{{item1.recharge_amount}}送{{item1.present_amount}}</div>
              <!-- <div class="discount" v-for="(item, i) in [1]" :key="i">充1000送1000</div> -->
              <img v-if="item.isshowfold" class="foldimg" :src="item.isfold?foldtop:foldbottom" alt="" @click="item.isfold=!item.isfold"/>
            </div>
          </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="back_top" @click="backTop" v-if="issearch">
        <img src="../../assets/shared-hotel/backtop.png" alt=""/>
        <div class="backtop_text">顶部</div>
    </div>
  </div>
</template>

<script>
import navBar from './components/navBar'
import dsbridge from 'dsbridge'
import { mapState, mapMutations } from "vuex";
export default {
  name:"store",
  data() {
    return {
      foldbottom:require("@/assets/shared-hotel/fold_bottom.png"),
      foldtop:require("@/assets/shared-hotel/fold_top.png"),
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      pageSize:10,
      latitude:'',  // 经度
      longitude:'',  // 纬度
      distance:0,
      storeId:'',
      selectedList: [
        {text: '距离最近', selected: true},
        {text: '充值最优惠', selected: false},
        {text: '可充值额度最高', selected: false},
      ],
      turn: false,
      client: 0,
      isToast: false,
      searchvalue:'',
      issearch:false,
      fn: null,
    }
  },

  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getOffshopUserInfo();
    this.deductionUA()
    this.latitude = this.$route.query.lat
    this.longitude = this.$route.query.long
     localStorage.setItem('longitude', this.$route.query.long)
    localStorage.setItem('latitude', this.$route.query.lat)
    // this.latitude = this.$route.query.lat
    // this.longitude = this.$route.query.long
  },
  mounted() {
    window.setLocation = this.setLocation 
    this.breakEvent('0');
    // const appDom = document.querySelector('.shared-hotel-app-restore-store')
    // this.fn = (e) => {
    //   if (appDom.scrollTop > 0) {
    //     this.issearch = true
    //   }
    //   if (appDom.scrollTop == 0) {
    //     this.issearch = false
    //   }
    // }
    // appDom.addEventListener('scroll', this.fn, false)
    document.addEventListener("scroll", this.scrollHander, true); // 监听页面滚动事件
  },
   destroyed() {
    const appDom = document.querySelector('body')
    appDom.removeEventListener('scroll', this.fn, false)
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  components:{
    navBar
  },
  methods: {
      //页面滚动监听方法
    scrollHander() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.issearch = true
      }
      if (scrollTop == 0) {
        this.issearch = false
      }
    },
      ...mapMutations(["setState"]),
      getOffshopUserInfo(){
        this.$api.post('/offshop/member/getUserInfo',{token:this.$route.query.token}).then((res)=>{
            this.userInfo.nickname = res.nickname;
            this.userInfo.user_id = res.user_id;
        });
    },
       //前往店铺详情搜索界面
    goDeatilSearch() {
      this.$router.push({
        path: "/sharedHotel/storeSearch",
        query: {
            long: this.longitude,
            lat:this.latitude
        },
      });
    },
      backTop(){
        // const appDom = document.querySelector('.shared-hotel-app-restore-store')
        // appDom.scrollTop = 0
        document.documentElement.scrollTop=0
    },
    getLocation(num) {
      this.params(JSON.stringify({ is_initiative : num,show_text : '我们需要获取您的地理位置权限，向您展示附近共享饭店信息及获取位置导航' }), JSON.stringify({ is_initiative : num,show_text : '我们需要获取您的地理位置权限，向您展示附近共享饭店信息及获取位置导航' }), "getLocation")
    },
    setLocation(location) {
      const _v = JSON.parse(location)
      this.longitude = _v.longitude
      this.latitude = _v.latitude
      this.page = 0
      this.list = []
      this.onLoad()
      
      if (this.isToast) {
        this.$toast('刷新成功')
      }
      this.isToast = true
      clearTimeout(this.timer)
      setTimeout(() => {
        this.turn = false 
      }, 200); 
    },
    goBack() {
      this.$router.go(-1)
    },
    // breakImg() {
    //   this.turn = true
    // },
    deductionUA() {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.client = 11
      } else if (/android/.test(ua)) {
        this.client = 10
      }
    },
    breakEvent(num) { 
      this.turn = true
      this.timer = setTimeout(() => {
        if (this.isToast) {
          this.$toast('刷新失败')
        }
        this.turn = false
      },3000)
        if (this.client === 10) {
            this.getLocation(num)
            return
        }
        if (this.client === 11) {
            dsbridge.call("getLocation", this.setLocation)
        }
    },
    clickCondition(item){
      item.selected = ! item.selected
    //   this.refreshing = true
    //   this.onRefresh()
        this.page = 0;
        this.getStoreList()
    },
    getMap(item) {
      let param = {
        lon: item.longitude,
        lat: item.latitude,
        address:item.address,
      }
      this.params(JSON.stringify(param),JSON.stringify(param),'getMap')
    },
    onLoad() {


      if (this.latitude && this.longitude) {
      // if (true) {
        // this.finished = false
        this.getStoreList()
        return
      }
      // 开始进来需要等待获取到经纬度之后才去 getStoreList
      let count = 0
      this.timer10 = setInterval(() => {
        if (this.latitude && this.longitude) {
          clearInterval(this.timer10)
          this.getStoreList();
        }

        count ++
        // 最多重试5次
        if (count >= 5) {
            clearInterval(this.timer10)
          this.loading = false;
          this.refreshing = false;
          this.finished = true
          this.turn = false
          return
        }

      }, 1000)


      // this.getStoreList();
    },
    onRefresh() {
      this.page = 0;
      // 清空列表数据
      this.finished = false;
       // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getStoreList() {
      this.page ++
      let params = {
        lng: this.longitude,
        lat: this.latitude,
        page:this.page,
        pageSize:this.pageSize,
        distance: this.selectedList[0].selected ? 1 : 0,
        discount: this.selectedList[1].selected ? 1 : 0,
        quota: this.selectedList[2].selected ? 1 : 0,
      }
  
      this.$api.post("/offshop/member/canteen/membership-card/applicability", params)
      .then((data) => {
        //控制折叠
        data.list.map((item)=>{
            let str=0;
            for(let i=0;i<item.recharge_promotion.length;i++){
                str+=item.recharge_promotion[i].recharge_amount.toString().length+item.recharge_promotion[i].present_amount.toString().length+2
            }
            if(str>=22){
                item.isshowfold=true;//超出24个字就先显示折叠的图标
                item.isfold=false;
            }
        })
        let _list = data.list
        if (this.refreshing||this.page==1) {
          this.list = [];
          this.finished = false;
        }

        this.list.push(..._list)

        if (this.list.length === 0 || _list.length === 0) {
          this.finished = true;
          this.loading = false;
          this.refreshing = false;
          return;
        }
        this.loading = false;

        if (data.current_page == data.last_page) {// 数据全部加载完成
          this.finished = true;
        }
        if (this.refreshing) {
          this.$toast("刷新成功");
          this.refreshing = false;
        }

        if (! this.finished && ! this.loading && this.list.length <= 3) {
          this.onLoad()
        }
        this.turn = false
      })
      .catch(()=>{
        this.loading = false;
        this.refreshing = false;
        this.finished = true
        this.turn = false
      })
     },
    toStoreInfo(item) {
      let param = {
        lon: item.longitude,
        lat: item.latitude,
        id: item.id,
      }
      this.$router.push({
        path: "/sharedHotel/storeDetail",
        query: {
            id: item.id,
            lng: item.longitude,
            lat: item.latitude,
        },
      });
    //   this.params(JSON.stringify(param),JSON.stringify(param),'toStoreInfo')
    },
  }
};
</script>

<style lang="less">
html,body{
    overflow-x: inherit;//取消外层滚动，内层不设置高度，解决keepAlive不生效
    overflow-y: inherit;//取消外层滚动，内层不设置高度，解决keepAlive不生效
}
.shared-hotel-app-restore-store {
  padding-top: 88px;
  width: 100%;
//   overflow-y: auto;
//   height: 100%;
  box-sizing: border-box;
  .back_top{
    width: 50px;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.11);
    border: 1px solid #EDEDED;
    border-radius: 50%;
    text-align: center;
    position: fixed;
    right: 5%;
    bottom:15%;
    img{
       width: 21px;
       height: 11px;
       margin-top: 10px;
    }
    .backtop_text{
        font-weight: 600;
        color: #999999;
        font-size:12px;
    }
  }
  .top-search-div {
  display: block;
  margin: 0 auto;
  width: calc(100% - 20px);
  padding-top: 6px;
  padding-bottom: 6px;
  box-sizing: border-box;
  position: relative;
  top:0px;
  margin-bottom:5px;
  input::-webkit-input-placeholder{
    color: #999999;
}
  input {
    height: 34px;
    width: calc(100% - 5px);
    border-radius: 20px;
    outline: none;
    border: none;
    text-indent: 38px;
    font-size: 14px;
    background: #f5f5f5;
  }
  .search-icon{
    width: 16px;
    height: 16px;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 14px;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: 100%;
    }
  }
}
  .nav-bar {
    .nav-bar-right {
      position: absolute;
      right: 0;
      margin: 0 16px;
      top: 52px;
      height: 29px;
      line-height: 29px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 14px;
        height: 12px;
        margin-right: 3px;
      }
      p {
        height: 18px;
        font-size: 13px;
        color: #666666;
        line-height: 18px;
      }
    }
  }
  .topcontent{
    background: #fff;
    position: fixed;
    top: 88px;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .condition {
    padding: 10px 12px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    // position: fixed;
    // top: 156px;
    // left: 0;
    background: #f5f5f5;
    // z-index: 99;
    .tag {
      font-size: 14px;
      color: #666666;
      width: 26.667%;
      line-height: 20px;
      background: #F5F5F5;
      border-radius: 3px;
      padding-top: 5px;
      padding-bottom: 5px;
      margin-right: 6px;
      text-align: center;
      &.tag-active {
        background: rgba(249, 89, 27, 0.1);
        color: #F9591B;
      }
      &:nth-of-type(3) {
        width: 42.067%;
      }
    }
  }

  .van-list {
    background-color: #F5F5F5;
    padding-top: 49px;
  }
  .empty-placehoder {
    padding-bottom: 1px;
    background-color: #F5F5F5;
  }

  .list-box {
    padding: 12px;
    margin: 10px 12px 0;
    display: flex;
    // border-bottom: 1px solid #f1f1f1;
    background-color: #fff;
    border-radius: 6px;

    .list-box-warpper {
      width: 100%;
      display: flex;
      // background-color: #fff;
      border-radius: 6px;
      
    }
    .list-box-left {
      margin-right: 6px;
      img {
        width: 64px;
        height: 64px;
        border-radius: 5px;
        object-fit:cover
      }
    }

    .list-box-right {
      width: calc(100% - 70px);
      .content {
        display: flex;
      }
      .left-amount {
        display: inline-block;
        padding: 2px 3px 1px;
        height: 17px;
        font-size: 12px;
        color: #F9591B;
        line-height: 17px;
        margin: 6px 0;
        background: rgba(249, 89, 27, 0.09);
        border-radius: 3px;
      }
      .right-amount{
          display: inline-block;
          padding: 2px 3px 1px;
          box-sizing: border-box;
          background: rgba(220,160,60,0.15);
            border-radius: 3px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #AE6C28;
      }
      .discounts {
          margin-top: 8px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .discount {
          position: relative;
          padding: 2px 4px 1px;
          margin: 0 6px 5px 0;
          height: 17px;
          font-size: 12px;
          color: #F9591B;
          line-height: 17px;
          border-radius: 3px;
          // border: 1px solid #F9591B;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            width: 200%;
            height: 200%;
            border: 1px solid #F9591B;
            border-radius: 6px; /* 也可以设置圆角 */
            transform-origin: 0 -4px;
            transform: scale(0.5, 0.5);
            box-sizing: border-box;
          }
        }
        .foldimg{
            position: absolute;
            right: 0px;
            top:6px;
            width: 10px;
            height: 8px;
        }
      }
    }

    .left {
      flex: 1;
      padding-right: 15px;
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .t-left {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          font-weight: bold;
        }
        .t-right {
        //   font-size: 16px;
        //   color: #666666;
          // padding-right: 15px;
          font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
      }
      .addres {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }

    }
    .right {
      width: 27px;
      height: 52px;
      border-left: 1px solid #eeeeee;
      position: relative;
      img {
        // width: 12px;
        // height: 17px;
        width: 16px;
        height: 18px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
    .turn{
      // width:100px;
      // height: 100px;
      // background: aqua;
      animation:turn 1s linear infinite;      
      // margin: 100px auto;
    }
    /* 
      turn : 定义的动画名称
      1s : 动画时间
      linear : 动画以何种运行轨迹完成一个周期
      infinite :规定动画应该无限次播放
     */
    @keyframes turn{
      0%{-webkit-transform:rotate(0deg);}
      25%{-webkit-transform:rotate(90deg);}
      50%{-webkit-transform:rotate(180deg);}
      75%{-webkit-transform:rotate(270deg);}
      100%{-webkit-transform:rotate(360deg);}
    }
}
</style>
